export default "__VITE_ASSET__028686a8__"